import {FC, useEffect, useContext, useState, useLayoutEffect} from "react";
import { useSearchParams } from "react-router-dom";
import { format } from "date-fns";

import { GeographicalStatisticsObject } from "./types";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastTypes } from "src/types";

import FooterText from "src/components/footerText";
import CaseVolume from "src/components/manufacturer/caseVolumeLineChart";
import GeographicalStatistics from "src/components/manufacturer/geographicalStatistics";
import CaseFilter from "src/components/manufacturer/statistics";
import { StatisticsSearchProps } from "src/components/manufacturer/statistics/types";
import {AuthContext} from "../../context/authContext";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import CustomTopPayorDetail from "src/components/manufacturer/customTopPayorDetail";
import CustomComponentForTransfer from "src/components/manufacturer/customComponentForTransfer";
import CustomComponentForPriorAuth from "src/components/manufacturer/customComponentPriorAuth";
import CustomComponentAreaCaseBySubmission from "src/components/manufacturer/customComponentAreaCaseBySubmission";

import { StatisticsApiResponse } from "../manufacturer/types";
import { areManFiltersUpdated, getDefaultManFilters } from "src/helpers/manufacturer";


const Regions: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  const [searchParams, updateSearchParams] = useSearchParams();
  // const location = useLocation();
  // const params = new URLSearchParams(location.search);
  // const insuranceName:string | null = params.get('insurance_name');

  const [queryParams, changeQueryParams] = useState(getDefaultManFilters(searchParams, userData, ""));



  // eslint-disable-next-line react-hooks/exhaustive-deps
  // useLayoutEffect(() => setLoader(), [])

  const { data: statisticsData, mutate: getStatsData } =
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  useEffect(() => {
    if (statisticsData) {
      hideLoader();
      if (statisticsData.code === 200) {
        showToast([statisticsData.message], ToastTypes.SUCCESS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData]);



  const updateQueryParamsAndCallAPI = (
    updatedQueries: StatisticsSearchProps,
    isReset: boolean = false
  ): void => {
    if (isReset) {
      updateSearchParams({});
      changeQueryParams({
        start_date: format(
          new Date().setDate(new Date().getDate() - 30),
          "yyyy-MM-dd"
        ),
        end_date: format(
          new Date().setDate(new Date().getDate()),
          "yyyy-MM-dd"
        ),
        period: "",
        filter_type: "",
        type: "regions",
        user_id: "",
        insurance_name: "",
        role: "",
      });
    } else {
      changeQueryParams((oldQueryParams) => ({ ...updatedQueries, ...oldQueryParams }));
    }

    setLoader();
    getStatsData({}, {}, updatedQueries);
  };

  const getStatisticsData = () => {
    const updatedQueries = {
      ...queryParams,
    }
    changeQueryParams(updatedQueries)
    getStatsData({}, {}, updatedQueries);
  }

  return (
    <div className="container-fluid overflow-auto">
      <AuthMaunfacturerSubHeader/>
      {statisticsData && (
        <CaseFilter
          defaultQueryParams={queryParams}
          updateQueryParams={updateQueryParamsAndCallAPI}
        />
      )}
      {statisticsData && (
        <CaseVolume 
          StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData}
          buttonShows={true}
        />
      )}
      {statisticsData && (
        <CustomTopPayorDetail StatisticsObjectType={statisticsData.data}/>
      )}

      {statisticsData && (
        <CustomComponentForTransfer StatisticsObjectType={statisticsData.data}/>
      )}

      {statisticsData && (
        <CustomComponentForPriorAuth StatisticsObjectType={statisticsData.data}/>
      )}

      {statisticsData && (
        <CustomComponentAreaCaseBySubmission 
          StatisticsObjectType={statisticsData.data} title="Regional Managers"
          queryParams={queryParams}
          isFilterObjUpdated={() => areManFiltersUpdated(queryParams, searchParams, userData, "")}
        />
      )}

      {statisticsData?.data && (
        <GeographicalStatistics
          GeographicalStatisticsListType={
            statisticsData?.data
              .geographical_stats as unknown as GeographicalStatisticsObject[]
          }
        />
      )}
      <FooterText footerType="black"/>
    </div>
  );
};

export default Regions;
